<template>
  <ul class="accordion">
    <li v-for="item in rmodel" :key="item.id" :class="[item.opened && item.active ? 'open': '', item.active ? 'byl-accordion-active' : '']">
      <item :model="item" @route-changed="routeChanged"></item>
    </li>
  </ul>
</template>
<script>
import item from './item.vue'
import utils from '@/utils'
export default {
  name: 'treeMenu',
  data () {
    return {
      rmodel: []
    }
  },
  mounted () {
  },
  watch: {
    model: {
      handler (val) {
        // console.log(val)
        this.rmodel = val
      },
      deep: true
    }
  },
  methods: {
    routeChanged (route) {
      this.$emit('route-changed', route)
      this.closeFolders(route) /* 其余打开着的folder是要关闭的 */
      this.blindMenus(route) /* 其余高亮着的menu熄灭的 */
    },
    hasChildren (arr) {
      return arr.filter((o) => {
        return o.children
      })
    },
    closeFolders (route) { // 关闭打开着的folder
      var folders = this.hasChildren(this.rmodel)
      var folders_to_close = folders.filter((o) => {
        return o !== route
      })
      if (route.children) { // 点击的是有下级菜单的项目, 无下级菜单则保持原状
        for (let i = 0; i < folders_to_close.length; i++) {
          var o = folders_to_close[i]
          o.opened = false
        }
      } else {
        if (route.level <= 1) { // 第一级的菜单项
          for (let i = 0; i < folders_to_close.length; i++) {
            let o = folders_to_close[i]
            o.opened = false
          }
        }
      }
    },
    blindMenus (route) {
      var _blind = function (obj) {
        for (let i = 0; i < obj.length; i++) {
          let o = obj[i]
          o.active = false
          o.opened = false
          if (o.children) {
            iteration(o.children)
          }
        }
      }
      function iteration (data) {
        for (var j = 0; j < data.length; j++) {
          data[j].opened = false // 菜单是否打开
          data[j].active = false // 是否高亮
          if (data[j].children != undefined && data[j].children.length > 0) {
            iteration(data[j].children)
          }
        }
      }
      var folders_toplevel_close = this.model.filter((o) => {
        return o !== route
      })
      for (let i = 0; i < folders_toplevel_close.length; i++) { // 保持自己所有上级菜单为打开状态
        var o = folders_toplevel_close[i]
        if (o.id == route.parentId) { // 找到该菜单自己的父级菜单
          o.active = true
          o.opened = true
        } else {
          // o.active = false
        }
      }
      if (route.level > 1) {
        if (route.opened && route.active) {
          if (route.children) {
            _blind(route.children)
          }
        }
        var p = this.$utils.deepQuery(this.model, route.parentId, 'id')
        if (p && !this.$utils.isEmptyObj(p)) {
          if (p.children) {
            var folders_to_close1 = p.children.filter((o) => {
              return o !== route
            })
            _blind(folders_to_close1)
          }
        }
      } else { // 点击第一级菜单时，别的第一级菜单的下属状态要置空
        if (route.opened && route.active) {
          if (route.children) {
            _blind(route.children)
          }
        }
        for (let i = 0; i < folders_toplevel_close.length; i++) {
          let o = folders_toplevel_close[i]
          o.active = false
          o.opened = false
          if (o.children) {
            iteration(o.children)
          }
        }
      }
    }
  },
  components: {
    item
  },
  props: ['model']
}
</script>
<style scoped>
  @import './index.css';
</style>



// WEBPACK FOOTER //
// src/components/common/accordion/index.vue